export class requeststatus {

 requeststatusinfoid:number
  requestdetailid: number;
  createdby: number;
  createdon: string;
  active: number; 
  requesttypeid: number;
  statusid: number;
  finalupload: string;
  containsgraphics: number = 0;
  finaluploadsupportingfiles: string;

}
